export enum UserFlowType {
  EXECUTOR_WELCOME_FLOW = 'executor_welcome_flow',
  EXECUTOR_INFORMATION_FLOW = 'executor_information_flow',
  ADVISOR_PRO_UPGRADE_FLOW = 'advisor_pro_upgrade_flow',
  REFERRAL_DIGITAL_VAULT_FLOW = 'referral_digital_vault_flow'
}
